<div class="modal-header">
  <h5 class="modal-title">{{ 'HEULocal' | translate }} </h5>
  <span class="close" aria-label="Close" (click)="onCancel()" *ngIf="canClose">
    <span aria-hidden="true">&times;</span>
  </span>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12">
      <div class="table-responsive">
        <div class="form-group col-sm-6 col-md-6 col-lg-6">
          <input class="form-control form-control-sm" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </div>

        <table cdk-table #table matSort [dataSource]="heuDataSource" class="table table-striped">

          <ng-container cdkColumnDef="actions">
            <th cdk-header-cell *cdkHeaderCellDef>
            </th>
            <td cdk-cell *cdkCellDef="let element">
              <a href="javascript:void(0);" class="icon select" (click)="selectHeu(element)"></a>
            </td>
          </ng-container>

          <ng-container cdkColumnDef="localNumber">
            <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="heu.localNumber">{{ 'LocalNumber' | translate }}
            </th>
            <td cdk-cell *cdkCellDef="let element">
              {{ element.heu.localNumber }}
            </td>
          </ng-container>

          <ng-container cdkColumnDef="localName">
            <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="heu.localName">{{ 'LocalUnionName' | translate }}
            </th>
            <td cdk-cell *cdkCellDef="let element">
              {{ element.heu.localName }}
            </td>
          </ng-container>

          <ng-container cdkColumnDef="city">
            <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="heu.city">{{ 'City' | translate }}
            </th>
            <td cdk-cell *cdkCellDef="let element">
              {{ element.heu.city }}
            </td>
          </ng-container>

          <ng-container cdkColumnDef="provinceDBID">
            <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="heu.provinceDBID">{{ 'Province' | translate }}
            </th>
            <td cdk-cell *cdkCellDef="let element">
              {{ element.heu.provinceDBID | decodeLookup: 'provinces' }}
            </td>
          </ng-container>

          <ng-container cdkColumnDef="status">
            <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="isActive" [ngClass]="'status-width'">{{'Status' |
                translate}}
            </th>
            <td cdk-cell *cdkCellDef="let element">
              <span class="status radius" [ngClass]="{ 'active': element.isActive, 'inactive': !element.isActive }">
                {{ (element.isActive ? 'Active' : 'Inactive') | translate }}
              </span>
            </td>
          </ng-container>

          <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>

        </table>
        <div class="panel-footer">
          <mrm-pagination [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" [length]="totalResults">
          </mrm-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer" *ngIf="canClose">
  <div class="text-right">
    <div class="panel-footer pull-right">
      <button class="btn btn-secondary" (click)="onCancel()">{{ 'Close' | translate }}</button>
    </div>
  </div>
</div>